import { render, staticRenderFns } from "./ViewTask.vue?vue&type=template&id=ed0a861c&scoped=true"
import script from "./ViewTask.vue?vue&type=script&lang=js"
export * from "./ViewTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0a861c",
  null
  
)

export default component.exports